import React, {useEffect, useRef} from "react";
import { Link, useParams } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import { ThumbUp } from "@material-ui/icons";
import Card from "../Card.js";
import Header from "../property/Header";

import { Context as AuthContext } from "../../context/auth.context";

const Disclaimer = () => {
  const { state } = React.useContext(AuthContext);
  const textRef = useRef();
  let { opID } = useParams();


    useEffect(() => {
      let htmlFromBackend = state.merchant.customDisclaimer;
      if (htmlFromBackend && textRef.current){
        textRef.current.innerHTML = htmlFromBackend
      } else {
        textRef.current.innerHTML = state.merchant.merchantName + ` Tax Office makes every effort to produce
        and publish the most accurate information possible; however, this
        material may be slightly dated which would have an impact on its
        accuracy. Any errors or omissions should be reported for
        investigation. No warranties, expressed or implied, are provided for
        the data herein, its use, or its interpretation. 
        <br><br> The assessed values are subject to change before being
        finalized for ad valorem tax purposes. The information should be used
        for informational use only and does not constitute a legal document
        for the description of these properties. ` + state.merchant.merchantName + `
        Tax Office disclaims any responsibility or liability for any direct or
        indirect damages resulting from the use of this data.`
      }
    })

  return (
    <>
      <Header />
      <Card>
        <Typography style={{ textAlign: "start" }} ref={textRef} ></Typography>

        {/* <Alert severity="info" style={styles.alert}>
          Please Note: If your address has changed, please complete the Address
          Change request form or contact the revenue office. Thank you.
        </Alert> */}

        <div style={styles.row}>
          <Link
            to={`/${opID}/search_records`}
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<ThumbUp />}
              onClick={() => window.scroll(0, 0)}
            >
              Accept
            </Button>
          </Link>
        </div>
      </Card>
    </>
  );
};

const styles = {
  divider: {
    width: 15,
  },
  alert: {
    marginTop: 25,
    marginBottom: 25,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    marginTop: 25,
  },
};

export default Disclaimer;
